import { styles } from './Reports.styles';

export const ReportsLoading = () => (
	<main className={styles.content}>
		<div className="h-[24px] w-[200px] animate-pulse rounded-md bg-grey-25" />
		<div className="grid grid-cols-1 gap-md md:grid-cols-2">
			<div className="h-[112px] animate-pulse rounded-md bg-grey-25" />
			<div className="h-[112px] animate-pulse rounded-md bg-grey-25" />
		</div>
		<div className="h-[240px] animate-pulse rounded-md bg-grey-25" />
	</main>
);
